import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import CommandCenterPage from '@/pages/CommandCenterPage';

export default function CommandModule() {
  const tabs = [
    { id: 'command', label: 'Executive Panels', content: <CommandCenterPage /> },
  ];

  return (
    <ModuleShell title="Command Center" subtitle="FMI-anchored executive panels — CEO to Chief Agents Officer" tabs={tabs} />
  );
}
